module.exports = __webpack_public_path__ + "/bundle/asset/faq-1-2-6b44f78ce0fab43298298e95b9a5fd42.png";